import { render, staticRenderFns } from "./added.vue?vue&type=template&id=c507ef1e&scoped=true&"
import script from "./added.vue?vue&type=script&lang=js&"
export * from "./added.vue?vue&type=script&lang=js&"
import style0 from "./added.vue?vue&type=style&index=0&id=c507ef1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c507ef1e",
  null
  
)

export default component.exports